import Macy from 'macy';
import getScrollbarWidth from 'get-scrollbar-width';
import { getBreakpoint } from '../tools/MQ';
import { fontLoader } from './fontFaceObserver';


export const init = () => {
	const element = document.querySelectorAll('.js-macy');

	if (!element.length) return;

	const SCROLLBAR_WIDTH = getScrollbarWidth();
	const DESKTOP_BP = getBreakpoint('desktopMin') - SCROLLBAR_WIDTH - 1;
	const TABLET_BP = getBreakpoint('tabletMin') - SCROLLBAR_WIDTH - 1;
	const OPTIONS = {
		container: '.js-macy',
		columns: 3,
		breakAt: {},
		trueOrder: true,
	};
	OPTIONS.breakAt[DESKTOP_BP] = { columns: 2 };
	OPTIONS.breakAt[TABLET_BP] = { columns: 1 };

	const macy = Macy(OPTIONS);

	const recalculate = () => macy.recalculate(true, true);

	fontLoader.then(() => recalculate());

	macy.runOnImageLoad(() => {
		recalculate();
	});
};



// WEBPACK FOOTER //
// ./src/js/components/macy.js